import type {
  RegistrationRequestListOrderBy,
  RegistrationRequestStatus,
  RegistrationRequestType,
  SortOrder,
} from "RegistrationRequests/Api/registrationRequestApi";

export const REGISTRATION_REQUESTS_QUERY_KEYS = {
  all: ["REGISTRATION_REQUESTS"] as const,
  list: (
    offset?: number,
    limit?: number,
    status?: RegistrationRequestStatus | null,
    type?: RegistrationRequestType | null,
    searchQuery?: string | null,
    orderBy?: RegistrationRequestListOrderBy,
    sortOrder?: SortOrder,
  ) =>
    [
      ...REGISTRATION_REQUESTS_QUERY_KEYS.all,
      "LIST",
      offset,
      limit,
      status,
      type,
      searchQuery,
      orderBy,
      sortOrder,
    ] as const,
  detail: (registrationRequestID: string) =>
    [
      ...REGISTRATION_REQUESTS_QUERY_KEYS.all,
      "DETAIL",
      registrationRequestID,
    ] as const,
} as const;
